

import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

export class MyMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams) {

    var result = `${params.key}`;

    if (params.key.indexOf('CUSTOMLIST') >= 0) {

      let paramSplit = params.key.split(".");

      let paramFinaly = paramSplit.splice(3, 3, paramSplit.length.toString()).join(".");

      result = paramFinaly

    }
    return result;
  }
}
